export const overrideProductsOriginalPayload = ({
  originalPayload,
  dmgVariant,
}) => {
  if (dmgVariant) {
    return {
      ...originalPayload,
      ...dmgVariant.productJson,
    };
  }

  return originalPayload;
};

export const getCustomerDmgVariant = ({ root, dmgVariants, dmGatewayCode }) => {
  if (root === 'quiz-complete' && dmgVariants) {
    return getDmgVariant(dmgVariants, dmGatewayCode);
  }
};

export const getDmgVariant = (dmgVariants, dmGatewayCode) => {
  if (!dmgVariants?.length || !dmGatewayCode) {
    return null;
  }

  return dmgVariants.find(dmgVariant =>
    dmgVariant.dmgCode.includes(dmGatewayCode)
  );
};
